import { Injectable } from '@angular/core';
import type { BLE } from '@awesome-cordova-plugins/ble/ngx';
import { HTTP } from '@awesome-cordova-plugins/http/ngx';
import { BleClient, numbersToDataView, numberToUUID } from '@capacitor-community/bluetooth-le';
import { Storage } from '@ionic/storage';
import type { Observable } from 'rxjs';
import { BehaviorSubject, Subject } from 'rxjs';
import {
  DeviceControllerService, SiteDeviceControllerService
} from 'src/app/shared/typescript-angular-client';

import { Device } from '../../shared/typescript-angular-client';
import { UserService } from '../user.service';

// //Protocole BT U-Link
// import { UlinkBleService } from '../bluetooth/ble.service';
// //Protocole BT Rayonics
// import { RayoBleService } from '../bluetooth-rayonics/ble.service';

@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  public deviceB: BehaviorSubject<Device> = new BehaviorSubject(new Device());
  public device: any;

  public user: any = {};

  public ble: BLE;
  public bleClient = BleClient;

  // Connexion
  public isConnected: boolean = false;
  public isConnecting: boolean = false;
  public auto_connect: boolean = false;
  public connectError: boolean = false;
  public connexionLoader: any;
  public mustActivate: boolean = false;

  // Action Update
  public hasUpdate: boolean = false;
  public updateInfos: any;
  public isUpdating: boolean = false;
  public percent: any;
  public hasToUpdate: boolean = false;
  public currentUpdate: any;
  public checkUpdate: boolean = false;
  public updateDispo: any;

  // Task
  public tasksToSend: any = [];
  public tasks: any = [];
  public cmdFromTask: boolean = false;
  public taskAction: any;
  public paramIndex: any;
  public paramsIsOk: boolean = false;
  public taskResponse: any;
  public currentCmdId: number = 0;
  public currentTaskId: number = 0;
  public mustSync: boolean = false;

  // Command
  public sendingCmd: boolean = false;
  public uniqueResponse: any;
  public uniqueInput: any;
  public cmd: any;
  public getTask: any;

  public bleService: any;
  public currentAction: any = [];
  updateEnd: boolean;
  checkEventt: boolean;

  public syncSubject: Subject<any>;
  public connectSubject: Subject<any>;

  constructor(
    protected storage: Storage,
    protected deviceApi: DeviceControllerService,
    protected siteDeviceApi: SiteDeviceControllerService,
    protected userService: UserService,
    protected HTTP: HTTP
  ) {
    this.syncSubject = new Subject<any>();
    this.connectSubject = new Subject<any>();
  }

  public async setDevice(deviceId: number): Promise<any> {
    const device = await this.deviceApi.deviceControllerFindById(deviceId).toPromise();
    this.deviceB.next(device);
    this.device = device;
    // if (device.properties.type === 'smartlock') {
    //   // this.bleService = rayoBleService;
    //   this.bleService =
    //     device.properties?.brand === 'rayonics'
    //       ? this.rayoBleService
    //       : this.ulinkBleService;
    // }
    return await this.storage.set('device', device);
  }

  public getDevice(): Observable<any> {
    if (this.deviceB.getValue() && this.deviceB.getValue().id) {
      return this.deviceB;
    } else {
      this.getDeviceStorage();
      return this.deviceB;
    }
  }

  public async unsetDevice(): Promise<any> {
    return new Promise((resolve) => {
      this.deviceB.next(new Device());
      this.device = undefined;
      this.storage.remove('device').then(() => resolve(true));
    });
  }

  public setRights(userId: any) {
    this.getDevice().subscribe((device) => {
      if (device.properties) {
        device.properties.collaborators.forEach((collab) => {
          if (collab.userId === userId) {
            return collab.rights ? collab.rights : {};
          }
        });
      }
    });
  }

  private setDeviceStorage(device: Device) {
    this.storage.set('device', device).then((res) => console.log(res));
  }

  public getDeviceStorage() {
    this.storage.get('device').then((device) => {
      this.deviceB.next(device);
    });
  }

  initUser() {
    console.log('INIT USER');
    this.userService.getUser().subscribe((user) => {
      this.user = user;
      console.log('initUser:', this.user);
    });
  }

  public disconnect() {
    console.log('ULinkBleService - Disconnecting device', this.device.bleId);
    // this.ble
    this.bleClient
      .disconnect(this.device.bleId)
      .then(() => {
        console.log('ULinkBleService -> ble disconnected', this.connectSubject);
        this.isConnecting = false;
        this.isConnected = false;
        this.connectSubject.next({
          device: this.device,
          status: 'disconnected',
        });
        this.resetVariables();
      })
      .catch((err) => {
        console.log('ULinkBleService => Error while disconnected device:', err);
        this.connectSubject.next({
          device: this.device,
          status: 'disconnect_error',
        });
      });
  }

  async syncTasks() {
    /*this.checkEvent();
    return;*/

    console.log('[DO TASK] START');
    if (!this.tasks || this.tasks.length <= 0)
      this.tasks = await this.deviceApi.GetDeviceTask(this.device.id).toPromise();
    // .subscribe(async (res) => {
    //   console.log('Tasks : ', res);
    //   this.tasks = res;
    // });
    //console.log("Check : " + this.tasks[0].properties.payload.commands.length + " - vs - " + this.currentTaskId);
    console.log('Tasks:', JSON.stringify(this.tasks));
    if (this.tasks[this.currentTaskId] == null || this.tasks[this.currentTaskId] == undefined) {
      console.log('Task', this.currentTaskId, 'undefined. Checking tasks to send');
      // if (this.cmdLoader != null && this.stopInput == false)
      //   this.cmdLoader.dismiss();

      this.tasksToSend = [
        ...new Map(this.tasksToSend.map((item) => [item['properties']['payload']['bytes']['data'], item])).values(),
      ];

      if (this.tasksToSend.length > 0)
        this.siteDeviceApi.siteDeviceConfirmTasks(this.device.id, this.tasksToSend).subscribe((task) => {
          console.log('[Task API] : ', task);
        });

      console.log('syncTasks finished, sync Hour');
      //RAYO => this.rayGetLockInfo(); ?

      // this.checkEvent();
      //Fin de la synchro après traitement des tâches
      // this.syncEnd = true;
      // this.isConnecting = false;
      // // this.stopInput = false;
      // this.currentAction.shift();
      // this.doRefresh();

      console.log(this.device.properties);
      const body = {
        value: new Date().toISOString(),
      };
      this.useCmd('hour');
      this.deviceApi.updateDevice(this.device.id, body, 'lastSync').subscribe((res) => {
        console.log('Last sync end : ', res);
      });
      //Correctif temporaire en attente de possibilité de marquer la synchro terminée depuis le service events
      // setTimeout(() => {
      //   this.doRefresh();
      // }, 3000);
      return;
    }

    if (this.tasks[this.currentTaskId].properties.payload.commands.length < this.currentCmdId) {
      console.log('Next taskId');
      this.currentTaskId += 1;
      this.currentCmdId = 0;
      this.syncTasks();
      return;
    }

    this.paramsIsOk = false;
    let task = this.tasks[this.currentTaskId].properties.payload.commands[this.currentCmdId];

    console.log('CurrentTaskId : ', this.currentTaskId);
    console.log('CurrentCmdId : ', this.currentCmdId);
    console.log('Current Task : ', task);

    if (task == undefined) {
      console.log('Next command index');
      this.currentCmdId += 1;
      this.syncTasks();
      return;
    }

    if (task.status == 'pending') {
      //task progress range 0.3 to 0.8 (30% to 80%)
      this.device.syncProgress = 0.5 * (this.currentTaskId / this.tasks.length) + 0.3;
      this.syncSubject.next({ device: this.device, status: 'sync' });
      this.cmdFromTask = true;
      switch (task.commandType) {
        case 'open':
          this.useCmd('openDoor');
          break;

        case 'writeParams':
          this.paramIndex = task.params[0].index;
          this.useCmd('params', task);
          break;

        case 'deleteParams':
          this.paramIndex = task.params[0].index;
          this.useCmd('params', task);
          break;

        default:
          break;
      }

      this.currentCmdId += 1;
    } else {
      this.currentCmdId += 1;
      this.syncTasks();
    }

    console.log('[DO TASK] END');
  }

  validateTask() {
    this.cmdFromTask = false;
    let task;
    let data;
    switch (this.taskAction) {
      // case "openDoor":
      //   let task = {
      //     properties: {
      //       payload: {
      //         type: "openAck",
      //         bytes: {
      //           type: "Buffer",
      //           data: [0x31],
      //         },
      //       },
      //     },
      //   };
      //   break;

      // case "stock":
      //   task = {
      //     properties: {
      //       payload: {
      //         type: "stockAck",
      //         bytes: {
      //           type: "Buffer",
      //           data: [0x26],
      //         },
      //       },
      //     },
      //   };
      //   break;

      case 'params':
        data = new Uint8Array(5);
        data[0] = 0x25;
        data[1] = 0x01;
        let dv = new DataView(data.buffer);
        dv.setUint16(2, this.paramIndex, true); //write index to uint16 little endian
        data[4] = !!this.paramsIsOk ? 0x00 : 0xFF;
        console.log('Index:',this.paramIndex);
        // let index = this.paramIndex.toString(16);
        // console.log(index);
        // index = index.substring(index.length - 2, index.length);
        // console.log('INDEX : ', index, 'INDEXPARAMS : ', this.paramIndex);
        // if (this.paramsIsOk) {
        //   if (this.paramIndex <= 255) {
        //     data = [0x25, 0x01, parseInt(index, 16), 0x00, 0x00];
        //   } else {
        //     data = [0x25, 0x01, parseInt(index, 16), 0x01, 0x00];
        //   }
        // } else {
        //   if (this.paramIndex <= 255) {
        //     data = [0x25, 0x01, parseInt(index, 16), 0x00, 0x00];
        //   } else {
        //     data = [0x25, 0x01, parseInt(index, 16), 0x01, 0x00];
        //   }
        // }

        task = {
          properties: {
            payload: {
              type: 'writeParamsAck',
              bytes: {
                type: 'Buffer',
                data: Array.from(data),
              },
            },
          },
        };
        break;
      case 'reset':
        data = [0x25, 0x01, 0x1e, 0x00, 0x00];
        task = {
          properties: {
            payload: {
              type: 'writeParamsAck',
              bytes: {
                type: 'Buffer',
                data: data,
              },
            },
          },
        };
        break;

      default:
        console.log('Try to validate an unknown command type:', this.taskAction);
        return;
    }
    console.log(task);
    this.tasksToSend.push(task);

    console.log('Task fin validate : ', this.tasksToSend);
    this.syncTasks();
    // setTimeout(() => {
    //   this.doTask();
    // }, 500);
  }

  public async useCmd(cmd, infos = null) { }

  public resetVariables() { }

  public buf2hex(buffer) {
    // buffer is an ArrayBuffer
    return Array.prototype.map.call(new Uint8Array(buffer), (x) => ('00' + x.toString(16)).slice(-2)).join('');
  }

  public async updateLastSync() {
    const body = {
      value: new Date().toISOString(),
    };
    this.deviceApi.updateDevice(this.device.id, body, 'lastSync').subscribe((res) => {
      console.log('Update lastsync end : ', res);
      this.deviceApi.updateDevice(this.device.id, body, 'lastSeen').subscribe((res) => {
        console.log('Last seen end : ', res);
      });
    });
  }
}
